<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getLookups");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.analysis.totalItems / this.filters.pageSize
      );
    },
    analysis() {
      return this.$store.state.analysis.analysisList;
    }, 
     analysisGroups() {
      return [
        {value:0,label:"الكل"} ,
        ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AnalysisGroups)]
      },

  },

  data() {
    return {
      permissions: this.$settingPermissions.analysisPermissions,

      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        analysisGroupId: 0,
        analysisName: null,
      },
      headers: [
        { text: 'اسم التحليل', value: 'analysisName' },
        { text: 'التصنيف ', value: 'analysisGroup' },
        { text: 'السعر', value: 'price' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      // analysis: [
      //   { label: 1, serviceName:"خدمة 1", price:"20.0 د", roomNo:"الغرفة 1" }
      // ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("analysis/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    }, 
    serviesDetailsView(item) {
      this.itemId = item.id;
      this.view = 4;
      // Implement edit logic
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف الخدمة";
          break;


      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {

      this.$store.dispatch(`analysis/${this.dialogType}`, this.itemId);

      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>